exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "electra-sub-page-header {\n  height: 32px;\n  opacity: 0;\n  pointer-events: none;\n  width: 100%; }\n\nbutton {\n  height: 62px;\n  position: absolute;\n  width: 100%; }\n\nbutton > div.button-text {\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: 300;\n  height: 16px;\n  left: 20px;\n  position: absolute;\n  right: 48px;\n  text-align: left;\n  top: 30px; }\n\nbutton > div.button-item-wrapper {\n  fill: #000;\n  height: 32px;\n  position: absolute;\n  right: 8px;\n  top: 22px;\n  width: 32px; }\n\nimg {\n  bottom: 36px;\n  margin: auto;\n  max-height: 64px;\n  max-width: 130px;\n  left: 0;\n  position: absolute;\n  right: 0; }\n\n/* Desktop */\n:host.desktop > electra-sub-page-header {\n  opacity: 1;\n  pointer-events: all; }\n\n:host.desktop button > div {\n  top: 50%;\n  transform: translateY(-50%); }\n\n:host.desktop button > div.button-item-wrapper > svg {\n  opacity: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/more/more.component.scss
// module id = 411
// module chunks = 1